import { useCallback, useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Pagination,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import "./Content.css";
import {
  faCaretDown,
  faCaretUp,
  faPen,
  faEye,
  faTrash,
  faBell,
  faClock,
  faInfoCircle,
  faGift,
  faBullhorn,
  faExclamationTriangle,
  faPercentage,
  faEnvelope,
  faQuestionCircle,
  faStar,
  faTrophy,
  faUserGraduate,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import {
  ACADIMAC,
  ANNOUNCEMNTS,
  baseURL,
  DELETEANNOUNCEMNTS,
} from "../../../API/API";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDataRefresh } from "../../../Pages/context/DataRefreshContext";

// خريطة الأيقونات المتاحة
const iconMap = {
  faBell,
  faClock,
  faInfoCircle,
  faGift,
  faBullhorn,
  faExclamationTriangle,
  faPercentage,
  faEnvelope,
  faQuestionCircle,
  faStar,
  faTrophy,
  faUserGraduate,
  faCheckCircle,
  faTimesCircle,
  faCalendarDays,
};

export default function Ads() {
  const [academicYears, setAcademicYears] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [Order, setOrder] = useState("id");
  const [OrderType, setOrderType] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);
  const [bulkAction, setBulkAction] = useState("");
  const [showmessage, setShowMessage] = useState(false);
  const [rowId, setrowId] = useState([]);
  const [indexpage, setindexPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const { refreshKey } = useDataRefresh();

  const fetchData = useCallback(async () => {
    try {
      const res = await axiosPrivate.post(`${baseURL}/${ANNOUNCEMNTS}`, {
        Order,
        OrderType,
        indexpage,
      });

      console.log("Ads Data:", res.data);
      setAcademicYears(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
    } catch (err) {
      console.error("خطأ في جلب الإعلانات:", err);
      setAcademicYears([]);
    }
  }, [axiosPrivate, Order, OrderType, indexpage]);

  useEffect(() => {
    fetchData();
  }, [fetchData, refreshKey]);

  async function deleteItems(selectedIds) {
    try {
      await axiosPrivate.delete(
        `${baseURL}/${DELETEANNOUNCEMNTS}`,
        {
          data: { ids: selectedIds },
        }
      );
      toast.success("تم حذف الإعلانات بنجاح");
      setSelectedItems([]);
      fetchData();
    } catch (err) {
      console.log(err);
      if (err.response?.status === 403) {
        toast.error("ليس لديك صلاحيات كافية لحذف هذه الإعلانات");
      } else if (err.response?.status === 404) {
        toast.error("الإعلان غير موجود");
      } else {
        toast.error("حدث خطأ أثناء حذف الإعلانات");
      }
    }
  }

  return (
    <div className="p-4 content" dir="rtl">
      <ToastContainer position="top-center" reverseOrder={false} />
      
      <div className="d-flex align-items-center mb-5 justify-content-between">
        <h4 className="fw-bold m-0">إدارة الإعلانات الديناميكية</h4>
        <Link to="/DashboardLayout/addads" style={{ textDecoration: "none" }}>
          <Button className="custom-brand-btn-dhash">إضافة إعلان جديد ➕</Button>
        </Link>
      </div>

      {/* Filters  */}
      <div className="d-flex mb-3 gap-2 flex-wrap">
        <Form.Select
          style={{ maxWidth: "240px" }}
          value={bulkAction}
          onChange={(e) => setBulkAction(e.target.value)}
        >
          <option value="">تنفيذ على العناصر المحددة</option>
          <option value="delete">حذف 🗑️</option>
        </Form.Select>

        <Button
          className="custom-brand-btn-dhash"
          variant="secondary"
          disabled={selectedItems.length === 0}
          onClick={() => {
            if (selectedItems.length > 0) {
              setShowMessage(true);
            }
          }}
        >
          تطبيق
        </Button>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <Table striped bordered hover className="align-middle text-center">
          <thead style={{ backgroundColor: "var(--brand-200)", color: "#fff" }}>
            <tr>
              <th style={{ textAlign: "right", paddingRight: "15px" }}>
                <div className="d-flex align-items-center gap-2">
                  <span>محتوى الإعلان</span>
                  <span className="d-flex flex-column align-items-center" style={{ fontSize: "10px", cursor: "pointer" }}>
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder("content");
                        setOrderType(true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder("content");
                        setOrderType(false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>

              <th>نوع العرض</th>
              
              <th>الجدولة الزمنية</th>

              <th>الحالة</th>

              <th>أدوات التحكم</th>

              <th>*</th>
            </tr>
          </thead>
          <tbody>
            {academicYears.map((row, index) => {
              const currentIcon = row.icon && iconMap[row.icon] ? iconMap[row.icon] : null;
              const isCountdown = row.type === "countdown" || row.display_type === "countdown";
              const isSticky = row.is_sticky === 1 || row.is_sticky === true;
              const isActive = row.is_active === 1 || row.is_active === true;
              const isDraft = row.is_draft === 1 || row.is_draft === true;

              return (
                <tr key={index}>
                  <td style={{ textAlign: "right", paddingRight: "15px" }}>
                    <div className="d-flex align-items-center gap-2">
                      {currentIcon && (
                        <span className="text-warning bg-dark p-1 px-2 rounded" style={{ fontSize: "14px" }}>
                          <FontAwesomeIcon icon={currentIcon} />
                        </span>
                      )}
                      <span className="fw-semibold">{row.content}</span>
                    </div>
                  </td>
                  
                  <td>
                    {isCountdown ? (
                      <span className="badge bg-danger p-2 px-3" style={{ borderRadius: "20px" }}>
                        عداد تنازلي ⏳
                      </span>
                    ) : (
                      <span className="badge bg-primary p-2 px-3" style={{ borderRadius: "20px" }}>
                        شريط بيلف 🔁 {isSticky && "(ثابت 📌)"}
                      </span>
                    )}
                  </td>
                  
                  <td style={{ fontSize: "13px" }}>
                    <div>من: <span className="text-muted">{row.start_date ? row.start_date.split(' ')[0] : "فوراً"}</span></div>
                    <div>إلى: <span className="text-muted">{row.end_date ? row.end_date.split(' ')[0] : (row.endDate ? row.endDate.split(' ')[0] : "-")}</span></div>
                  </td>

                  <td>
                    <div className="d-flex flex-column gap-1 align-items-center">
                      {isActive ? (
                        <span className="badge bg-success p-1 px-2">نشط ✅</span>
                      ) : (
                        <span className="badge bg-secondary p-1 px-2">معطل ❌</span>
                      )}
                      {isDraft && (
                        <span className="badge bg-warning text-dark p-1 px-2">مسودة 📝</span>
                      )}
                    </div>
                  </td>

                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <OverlayTrigger placement="top" overlay={<Tooltip>حذف</Tooltip>}>
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() => {
                            setrowId([row.id]);
                            setShowMessage(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </OverlayTrigger>

                      <OverlayTrigger placement="top" overlay={<Tooltip>تعديل</Tooltip>}>
                        <Link
                          to="/DashboardLayout/updateads"
                          state={{ id: row.id }}
                        >
                          <Button size="sm" variant="outline-warning">
                            <FontAwesomeIcon
                              icon={faPen}
                              style={{ color: "#FFA500" }}
                            />
                          </Button>
                        </Link>
                      </OverlayTrigger>
                      
                      <OverlayTrigger placement="top" overlay={<Tooltip>عرض التفاصيل</Tooltip>}>
                        <Button
                          size="sm"
                          variant="outline-info"
                          onClick={() => {
                            setPreviewData(row);
                            setShowPreviewModal(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faEye} style={{ color: "#17A2B8" }} />
                        </Button>
                      </OverlayTrigger>
                    </div>
                  </td>
                  
                  <td>
                    <Form.Check
                      type="checkbox"
                      checked={selectedItems.includes(row.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedItems((prev) => [...prev, row.id]);
                        } else {
                          setSelectedItems((prev) =>
                            prev.filter((id) => id !== row.id)
                          );
                        }
                      }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Pagination
        className="justify-content-center custom-pagination mt-4"
        dir="ltr"
      >
        <Pagination.Prev
          onClick={() => {
            if (indexpage > 1) setindexPage(indexpage - 1);
          }}
          disabled={indexpage === 1}
        />

        {[...Array(totalPages).keys()]
          .map((n) => n + 1)
          .filter(
            (page) =>
              page === 1 ||
              page === totalPages ||
              (page >= indexpage - 2 && page <= indexpage + 2)
          )
          .map((page, i, arr) => {
            const prevPage = arr[i - 1];
            if (prevPage && page - prevPage > 1) {
              return [
                <Pagination.Ellipsis key={`ellipsis-${page}`} disabled />,
                <Pagination.Item
                  key={page}
                  active={indexpage === page}
                  onClick={() => setindexPage(page)}
                >
                  {page}
                </Pagination.Item>,
              ];
            }

            return (
              <Pagination.Item
                key={page}
                active={indexpage === page}
                onClick={() => setindexPage(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

        <Pagination.Next
          onClick={() => {
            if (indexpage < totalPages) setindexPage(indexpage + 1);
          }}
          disabled={indexpage === totalPages}
        />
      </Pagination>

      {/* Preview Modal */}
      {showPreviewModal && (
        <Modal
          show={showPreviewModal}
          onHide={() => setShowPreviewModal(false)}
          centered
          dir="rtl"
        >
          <Modal.Header className="position-relative border-0 bg-light">
            <Modal.Title className="fw-bold fs-5">تفاصيل الإعلان الديناميكي</Modal.Title>
            <Button
              variant="danger"
              onClick={() => setShowPreviewModal(false)}
              className="position-absolute top-0 left-0 ms-3 mt-2 p-0 rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                fontWeight: "bold",
                fontSize: "16px",
                left: "15px"
              }}
            >
              ×
            </Button>
          </Modal.Header>
          <Modal.Body className="p-4">
            {previewData ? (
              <div style={{ lineHeight: "1.8", fontSize: "15px" }}>
                <p className="border-bottom pb-2">
                  <strong>نص الإعلان: </strong> <span className="text-primary fw-semibold">{previewData.content}</span>
                </p>
                
                <div className="row mt-3">
                  <div className="col-6">
                    <p><strong>النوع: </strong> {previewData.type === "text" ? "نص فقط" : previewData.type === "icon" ? "نص + أيقونة" : "عداد تنازلي"}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>الأيقونة: </strong> {previewData.icon || "بدون"}</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-6">
                    <p><strong>طريقة العرض: </strong> {previewData.display_type === "countdown" ? "عداد تنازلي" : "شريط بيلف"}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>حالة التثبيت: </strong> {previewData.is_sticky ? "ثابت" : "متحرك"}</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-6">
                    <p><strong>سرعة الحركة: </strong> {previewData.scroll_speed || "عادية"}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>اتجاه الحركة: </strong> {previewData.scroll_direction === "left" ? "لليسار" : "لليمين"}</p>
                  </div>
                </div>

                <div className="row mt-3 border-top pt-2 bg-light p-2 rounded">
                  <div className="col-6">
                    <p className="m-0"><strong>تاريخ البدء: </strong> {previewData.start_date ? previewData.start_date.split(' ')[0] : "فوري"}</p>
                  </div>
                  <div className="col-6">
                    <p className="m-0"><strong>تاريخ الانتهاء: </strong> {previewData.end_date ? previewData.end_date.split(' ')[0] : (previewData.endDate ? previewData.endDate.split(' ')[0] : "-")}</p>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-6">
                    <p><strong>تفعيل الإعلان: </strong> {previewData.is_active ? <span className="text-success fw-bold">نشط ✅</span> : <span className="text-danger fw-bold">معطل ❌</span>}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>حالة الحفظ: </strong> {previewData.is_draft ? <span className="text-warning fw-bold">مسودة 📝</span> : <span className="text-success fw-bold">منشور 🚀</span>}</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center text-muted p-4">لا توجد بيانات</div>
            )}
          </Modal.Body>
        </Modal>
      )}

      {showmessage && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <h2>
              <BsExclamationTriangleFill className="text-warning fs-1 me-2" />
              ستقوم بحذف العناصر المحددة
            </h2>
            <div>
              <p>لن تتمكن من التراجع عن هذا الإجراء.</p>
            </div>

            <div className="d-flex justify-content-start gap-3 mt-4">
              <button
                className="btn btn-danger"
                onClick={() => {
                  if (rowId.length > 0) {
                    deleteItems(rowId);
                    setrowId([]);
                  }

                  setShowMessage(false);
                  if (bulkAction === "delete") {
                    deleteItems(selectedItems);
                  }
                }}
              >
                تاكيد الحذف
              </button>

              <button
                className="btn btn-outline-secondary"
                onClick={() => {
                  setShowMessage(false);
                }}
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
